var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address-list"},[_c('list',{attrs:{"fs":_vm.addressFields,"api":"addresses","apiList":"addresses/my","editLink":"/admin/addresses","addLink":"/admin/addresses/new"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }